// import React from "react";
// import { motion } from "framer-motion";
// import { Users, Target, ArrowUp, ArrowDown } from "lucide-react";
// import { GrMoney } from "react-icons/gr";

// const ProfessionalWidget = ({
//   farmersTarget,
//   AchievedFarmers,
//   SalesTarget,
//   ArchievedSales,
// }) => {
//   const achievementPercentage = (AchievedFarmers / farmersTarget) * 100;
//   const achievementPercnt = (ArchievedSales / SalesTarget) * 100;

//   // Simple, stable entrance animation
//   const itemVariants = {
//     hidden: {
//       opacity: 1,
//       y: 0,
//     },
//     visible: {
//       opacity: 1,
//       y: 0,
//     },
//   };

//   const CircularProgress = ({ percentage }) => {
//     const radius = 18;
//     const circumference = 2 * Math.PI * radius;
//     const progress = Math.min(Math.max(percentage, 0), 100);
//     const offset = circumference - (progress / 100) * circumference;

//     return (
//       <div className="relative flex h-[46px] w-[46px] shrink-0 items-center justify-center">
//         {/* Background ring */}
//         <svg width="46" height="46" viewBox="0 0 46 46" className="-rotate-90">
//           <circle
//             cx="23"
//             cy="23"
//             r={radius}
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="6"
//             className="text-gray-100 dark:text-gray-800"
//           />

//           <motion.circle
//             cx="23"
//             cy="23"
//             r={radius}
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="6"
//             strokeLinecap="round"
//             className="text-green-600"
//             strokeDasharray={circumference}
//             initial={{
//               strokeDashoffset: circumference,
//             }}
//             animate={{
//               strokeDashoffset: offset,
//             }}
//             transition={{
//               duration: 0.8,
//               ease: "easeOut",
//             }}
//           />
//         </svg>

//         <span className="absolute text-[9px] font-semibold text-green-700 dark:text-green-400">
//           {percentage.toFixed(0)}%
//         </span>
//       </div>
//     );
//   };

//   const Trend = ({ value }) => {
//     const positive = value > 0;

//     return (
//       <div className="flex shrink-0 items-center gap-1 rounded-full bg-green-100/80 px-2.5 py-1 text-[11px] font-medium text-green-700 dark:bg-green-900/30 dark:text-green-400">
//         {positive ? (
//           <ArrowUp className="w-3 h-3" strokeWidth={2.5} />
//         ) : (
//           <ArrowDown className="w-3 h-3" strokeWidth={2.5} />
//         )}

//         <span>{Math.abs(value)}%</span>
//       </div>
//     );
//   };

//   const StatCard = ({
//     icon: Icon,
//     title,
//     value,
//     subtitle,
//     trend,
//     percentage,
//     isCurrency = false,
//   }) => {
//     return (
//       <motion.div
//         variants={itemVariants}
//         whileHover={{
//           y: -3,
//           transition: {
//             duration: 0.2,
//           },
//         }}
//         className="group relative min-h-[205px] overflow-hidden rounded-[18px] border border-[#e3e8df] bg-white px-5 py-5 shadow-[0_4px_18px_rgba(30,60,30,0.06)] transition-shadow duration-300 hover:shadow-[0_10px_28px_rgba(30,60,30,0.09)] dark:border-gray-800 dark:bg-gray-900"
//       >
//         {/* Top section */}
//         <div className="flex items-start justify-between">
//           {/* Icon / Progress */}
//           {percentage !== undefined ? (
//             <CircularProgress percentage={percentage} />
//           ) : (
//             <motion.div
//               whileHover={{
//                 scale: 1.05,
//                 rotate: 2,
//               }}
//               transition={{ duration: 0.2 }}
//               className="flex h-[40px] w-[40px] items-center justify-center rounded-[11px] bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400"
//             >
//               <Icon className="h-[19px] w-[19px]" strokeWidth={2} />
//             </motion.div>
//           )}

//           {/* Trend */}
//           <Trend value={trend} />
//         </div>

//         {/* Content */}
//         <div className="mt-5">
//           <p className="text-[13px] font-medium tracking-[0.01em] text-gray-700 dark:text-gray-300">
//             {title}
//           </p>

//           <div
//             className={`mt-0.5 font-semibold leading-[1.05] tracking-[-0.03em] text-gray-950 dark:text-white ${
//               isCurrency
//                 ? "text-[25px] xl:text-[27px]"
//                 : "text-[27px] xl:text-[29px]"
//             }`}
//           >
//             {value}
//           </div>
//         </div>

//         {/* Subtitle */}
//         <p className="mt-5 text-[12px] font-medium text-gray-500 dark:text-gray-400">
//           {subtitle}
//         </p>

//         {/* Very subtle bottom accent */}
//         <div className="absolute bottom-0 h-px left-5 right-5 bg-gradient-to-r from-transparent via-green-200/60 to-transparent dark:via-green-900/40" />
//       </motion.div>
//     );
//   };

//   return (
//     <div className="hidden md:block">
//       {/* Dashboard heading */}
//       <motion.div
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{
//           duration: 0.25,
//           ease: "easeOut",
//         }}
//         className="flex items-center justify-between mb-4"
//       >
//         <div>
//           <div className="flex items-center gap-2">
//             <div className="w-2 h-2 bg-green-500 rounded-full" />

//             <span className="text-xs font-semibold uppercase tracking-[0.16em] text-green-600 dark:text-green-500">
//               Overview
//             </span>
//           </div>

//           <h2 className="mt-1 text-base font-bold tracking-tight text-gray-900 dark:text-white">
//             Performance Overview
//           </h2>
//         </div>

//         <div className="items-center hidden gap-2 px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 dark:border-gray-800 dark:bg-gray-900/50 lg:flex">
//           <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />

//           <span className="text-xs font-medium text-gray-500 dark:text-gray-400">
//             Live performance
//           </span>
//         </div>
//       </motion.div>

//       <motion.div initial="hidden" animate="visible">
//         {/* Stats Grid */}
//         <div className="grid grid-cols-1 gap-4 w-54 lg:grid-cols-4 xl:grid-cols-4">
//           <StatCard
//             icon={Target}
//             title="Farmers Target"
//             value={farmersTarget.toLocaleString()}
//             subtitle="Farmers to register"
//             trend={8.2}
//           />

//           <StatCard
//             icon={Users}
//             title="Registered Farmers"
//             value={AchievedFarmers.toLocaleString()}
//             subtitle={`${achievementPercentage.toFixed(1)}% of target`}
//             trend={achievementPercentage?.toFixed(2)}
//             percentage={achievementPercentage}
//           />

//           <StatCard
//             icon={Target}
//             title="Target Sales"
//             value={
//               <div className="flex flex-col gap-3 xl:flex-row xl:items-center">
//                 <span className="block font-semibold">TZS</span>
//                 <span className="block">{SalesTarget.toLocaleString()}</span>
//               </div>
//             }
//             subtitle="Revenue target"
//             trend={5.8}
//             isCurrency
//           />

//           <StatCard
//             icon={GrMoney}
//             title="Achieved Sales"
//             value={
//               <div className="flex flex-col gap-3 xl:flex-row xl:items-center">
//                 <span className="block font-semibold">TZS</span>
//                 <span className="block">{ArchievedSales.toLocaleString()}</span>
//               </div>
//             }
//             subtitle="Revenue generated"
//             trend={achievementPercnt?.toFixed(2)}
//             percentage={achievementPercnt}
//             isCurrency
//           />
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default ProfessionalWidget;
import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Users, Target, ArrowUp, ArrowDown } from "lucide-react";
import { GrMoney } from "react-icons/gr";

/* ----------------------------------------
   HELPERS
----------------------------------------- */

const toSafeNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

const calculatePercentage = (achieved, target) => {
  const safeAchieved = toSafeNumber(achieved);
  const safeTarget = toSafeNumber(target);

  if (safeTarget <= 0) {
    return 0;
  }

  return (safeAchieved / safeTarget) * 100;
};

const formatNumber = (value) => toSafeNumber(value).toLocaleString();

/* ----------------------------------------
   CIRCULAR PROGRESS
----------------------------------------- */

const CircularProgress = ({ percentage, reduceMotion }) => {
  const radius = 18;
  const circumference = 2 * Math.PI * radius;

  const safePercentage = Number.isFinite(Number(percentage))
    ? Number(percentage)
    : 0;

  /*
   * Circle stops at 100%.
   *
   * Text can still show 110%, 120%, etc.
   * when the target has been exceeded.
   */
  const progress = Math.min(Math.max(safePercentage, 0), 100);

  const offset = circumference - (progress / 100) * circumference;

  return (
    <div
      className="relative flex h-[46px] w-[46px] shrink-0 items-center justify-center"
      role="progressbar"
      aria-label="Target achievement"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(progress)}
      aria-valuetext={`${safePercentage.toFixed(0)}% of target`}
    >
      <svg
        width="46"
        height="46"
        viewBox="0 0 46 46"
        className="-rotate-90"
        aria-hidden="true"
      >
        <circle
          cx="23"
          cy="23"
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth="6"
          className="text-gray-100 dark:text-gray-800"
        />

        <motion.circle
          cx="23"
          cy="23"
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth="6"
          strokeLinecap="round"
          className="text-green-600"
          strokeDasharray={circumference}
          initial={
            reduceMotion
              ? false
              : {
                  strokeDashoffset: circumference,
                }
          }
          animate={{
            strokeDashoffset: offset,
          }}
          transition={{
            duration: reduceMotion ? 0 : 0.8,
            ease: "easeOut",
          }}
        />
      </svg>

      <span className="absolute text-[9px] font-semibold text-green-700 dark:text-green-400">
        {safePercentage.toFixed(0)}%
      </span>
    </div>
  );
};

/* ----------------------------------------
   TREND
----------------------------------------- */

const Trend = ({ value }) => {
  const trend = Number(value);

  if (!Number.isFinite(trend)) {
    return null;
  }

  const positive = trend > 0;
  const negative = trend < 0;

  return (
    <div
      className="flex shrink-0 items-center gap-1 rounded-full bg-green-100/80 px-2.5 py-1 text-[11px] font-medium text-green-700 dark:bg-green-900/30 dark:text-green-400"
      aria-label={
        positive
          ? `${trend}% increase`
          : negative
            ? `${Math.abs(trend)}% decrease`
            : "No change"
      }
    >
      {positive && (
        <ArrowUp className="w-3 h-3" strokeWidth={2.5} aria-hidden="true" />
      )}

      {negative && (
        <ArrowDown className="w-3 h-3" strokeWidth={2.5} aria-hidden="true" />
      )}

      <span>{Math.abs(trend).toFixed(1)}%</span>
    </div>
  );
};

/* ----------------------------------------
   STAT CARD
----------------------------------------- */

const StatCard = ({
  icon: Icon,
  title,
  value,
  subtitle,
  trend,
  percentage,
  reduceMotion,
  isCurrency = false,
}) => {
  const hasPercentage = percentage !== undefined && percentage !== null;

  return (
    <motion.div
      initial={
        reduceMotion
          ? false
          : {
              opacity: 0,
              y: 12,
            }
      }
      animate={{
        opacity: 1,
        y: 0,
      }}
      whileHover={
        reduceMotion
          ? undefined
          : {
              y: -3,
            }
      }
      transition={{
        duration: 0.25,
        ease: "easeOut",
      }}
      className="group relative min-h-[205px] overflow-hidden rounded-[18px] border border-[#e3e8df] bg-white px-5 py-5 shadow-[0_4px_18px_rgba(30,60,30,0.06)] transition-shadow duration-300 hover:shadow-[0_10px_28px_rgba(30,60,30,0.09)] dark:border-gray-800 dark:bg-gray-900"
    >
      {/* Card Header */}
      <div className="flex items-start justify-between">
        {hasPercentage ? (
          <CircularProgress
            percentage={percentage}
            reduceMotion={reduceMotion}
          />
        ) : (
          <motion.div
            whileHover={
              reduceMotion
                ? undefined
                : {
                    scale: 1.05,
                    rotate: 2,
                  }
            }
            transition={{
              duration: 0.2,
            }}
            className="flex h-[40px] w-[40px] items-center justify-center rounded-[11px] bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400"
          >
            <Icon className="h-[19px] w-[19px]" aria-hidden="true" />
          </motion.div>
        )}

        {trend !== undefined && trend !== null && <Trend value={trend} />}
      </div>

      {/* Main Value */}
      <div className="mt-5">
        <p className="text-[13px] font-medium tracking-[0.01em] text-gray-700 dark:text-gray-300">
          {title}
        </p>

        <div
          className={`mt-0.5 font-semibold leading-[1.05] tracking-[-0.03em] text-gray-950 dark:text-white ${
            isCurrency
              ? "text-[25px] xl:text-[27px]"
              : "text-[27px] xl:text-[29px]"
          }`}
        >
          {value}
        </div>
      </div>

      {/* Supporting Information */}
      <p className="mt-5 text-[12px] font-medium text-gray-500 dark:text-gray-400">
        {subtitle}
      </p>

      <div className="absolute bottom-0 h-px left-5 right-5 bg-gradient-to-r from-transparent via-green-200/60 to-transparent dark:via-green-900/40" />
    </motion.div>
  );
};

/* ----------------------------------------
   MAIN COMPONENT
----------------------------------------- */

const ProfessionalWidget = ({
  farmersTarget = 0,
  AchievedFarmers = 0,
  SalesTarget = 0,
  ArchievedSales = 0,

  /*
   * Optional REAL trend values.
   *
   * Example:
   * farmersTrend = percentage increase
   * compared with last month.
   */
  farmersTrend,
  salesTrend,
}) => {
  const reduceMotion = useReducedMotion();

  const safeFarmersTarget = toSafeNumber(farmersTarget);

  const safeAchievedFarmers = toSafeNumber(AchievedFarmers);

  const safeSalesTarget = toSafeNumber(SalesTarget);

  const safeAchievedSales = toSafeNumber(ArchievedSales);

  const farmerAchievement = calculatePercentage(
    safeAchievedFarmers,
    safeFarmersTarget,
  );

  const salesAchievement = calculatePercentage(
    safeAchievedSales,
    safeSalesTarget,
  );

  return (
    <section aria-labelledby="performance-heading" className="hidden md:block">
      {/* Dashboard Heading */}
      <motion.div
        initial={
          reduceMotion
            ? false
            : {
                opacity: 0,
                y: -4,
              }
        }
        animate={{
          opacity: 1,
          y: 0,
        }}
        transition={{
          duration: 0.25,
          ease: "easeOut",
        }}
        className="flex items-center justify-between mb-4"
      >
        <div>
          <div className="flex items-center gap-2">
            <div
              className="w-2 h-2 bg-green-500 rounded-full"
              aria-hidden="true"
            />

            <span className="text-xs font-semibold uppercase tracking-[0.16em] text-green-600 dark:text-green-500">
              Overview
            </span>
          </div>

          <h2
            id="performance-heading"
            className="mt-1 text-base font-bold tracking-tight text-gray-900 dark:text-white"
          >
            Performance Overview
          </h2>
        </div>

        <div className="items-center hidden gap-2 px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 dark:border-gray-800 dark:bg-gray-900/50 lg:flex">
          <div
            className="w-2 h-2 bg-green-500 rounded-full animate-pulse motion-reduce:animate-none"
            aria-hidden="true"
          />

          <span className="text-xs font-medium text-gray-500 dark:text-gray-400">
            Live performance
          </span>
        </div>
      </motion.div>

      {/* Statistics Grid */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard
          icon={Target}
          title="Farmers Target"
          value={formatNumber(safeFarmersTarget)}
          subtitle="Farmers to register"
          reduceMotion={reduceMotion}
        />

        <StatCard
          icon={Users}
          title="Registered Farmers"
          value={formatNumber(safeAchievedFarmers)}
          subtitle={`${farmerAchievement.toFixed(1)}% of target`}
          percentage={farmerAchievement}
          trend={farmersTrend}
          reduceMotion={reduceMotion}
        />

        <StatCard
          icon={Target}
          title="Target Sales"
          value={
            <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
              <span className="font-semibold">TZS</span>

              <span>{formatNumber(safeSalesTarget)}</span>
            </div>
          }
          subtitle="Revenue target"
          isCurrency
          reduceMotion={reduceMotion}
        />

        <StatCard
          icon={GrMoney}
          title="Achieved Sales"
          value={
            <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
              <span className="font-semibold">TZS</span>

              <span>{formatNumber(safeAchievedSales)}</span>
            </div>
          }
          subtitle={`${salesAchievement.toFixed(1)}% of revenue target`}
          percentage={salesAchievement}
          trend={salesTrend}
          isCurrency
          reduceMotion={reduceMotion}
        />
      </div>
    </section>
  );
};

export default ProfessionalWidget;
